"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("moment/locale/es");

require("moment/locale/fr");

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Set timzeone to Ecuador's so we always display stuff in local time
_momentTimezone["default"].tz.setDefault('America/Guayaquil');

var _default = _momentTimezone["default"];
exports["default"] = _default;